export const TAX_PROFILE_SOURCE_TYPES = {
  MANUAL: 'manual',
  ERP_GATEWAY: 'erp_gateway'
} as const;

export const TAX_PROFILE_SOURCE_TYPE_VALUES = Object.values(TAX_PROFILE_SOURCE_TYPES);
export type TaxProfileSourceType = typeof TAX_PROFILE_SOURCE_TYPE_VALUES[number];

export const TAX_PROFILE_STATES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const;

export const TAX_PROFILE_STATE_VALUES = Object.values(TAX_PROFILE_STATES);
export type TaxProfileState = typeof TAX_PROFILE_STATE_VALUES[number];

export const TAX_PROFILE_TAX_STATES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const;

export const TAX_PROFILE_TAX_STATE_VALUES = Object.values(TAX_PROFILE_TAX_STATES);
export type TaxProfileTaxState = typeof TAX_PROFILE_TAX_STATE_VALUES[number];

export const ERP_MANAGED_PROFILE_FIELDS = ['name'];
export const ERP_MANAGED_TAX_FIELDS = ['tax_name', 'rate', 'effective_start_date', 'effective_end_date'];
